module.exports = __webpack_public_path__ + "static/media/2.438713c2.jpg";